module.exports = __webpack_public_path__ + "img/pantalla-9-9.eb46942c.png";